import { useState } from "react";
import { X, BookOpen, HelpCircle, Wind, MessageCircleHeart } from "lucide-react";
import { Lesson } from "@/components/alignment/Lesson";
import { Quiz } from "@/components/alignment/Quiz";
import { BreathingExercise } from "@/components/alignment/BreathingExercise";
import { ReflectionChat } from "@/components/alignment/ReflectionChat";

const TABS = [
  { id: "lesson", label: "Lesson", icon: BookOpen },
  { id: "quiz", label: "Quiz", icon: HelpCircle },
  { id: "breathe", label: "Breathe", icon: Wind },
  { id: "reflect", label: "Reflect", icon: MessageCircleHeart },
];

export const WorldPanel = ({ world, breathingUnlocked, onComplete, onClose }) => {
  const [tab, setTab] = useState("lesson");
  const accent = world.theme?.primary || "#A78BFA";

  return (
    <div
      data-testid="world-panel"
      className="rounded-2xl border bg-white/[0.03] backdrop-blur-md overflow-hidden"
      style={{ borderColor: `${accent}33`, boxShadow: `0 0 80px ${world.theme?.glow || "rgba(167,139,250,0.2)"}` }}
    >
      <div className="flex items-center justify-between p-6 border-b border-white/10" style={{ background: `${accent}0d` }}>
        <div>
          <p className="text-xs tracking-[0.25em] uppercase mb-1" style={{ color: accent }}>{world.element} · {world.tagline}</p>
          <h2 className="font-head font-900 text-2xl sm:text-3xl text-slate-50">{world.name}</h2>
        </div>
        <button data-testid="close-world-btn" onClick={onClose} className="p-2 rounded-lg border border-white/10 text-slate-400 hover:text-slate-100 hover:border-white/30 transition-colors duration-300">
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="flex gap-1 p-2 border-b border-white/10 overflow-x-auto">
        {TABS.map((t) => {
          const Icon = t.icon;
          const activeTab = tab === t.id;
          return (
            <button
              key={t.id}
              data-testid={`world-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm whitespace-nowrap transition-colors duration-300 ${activeTab ? "text-slate-900" : "text-slate-300 hover:text-slate-100"}`}
              style={activeTab ? { background: accent } : {}}
            >
              <Icon className="w-4 h-4" /> {t.label}
            </button>
          );
        })}
      </div>

      <div className="p-6 sm:p-8">
        {tab === "lesson" && <Lesson world={world} accent={accent} onComplete={onComplete} />}
        {tab === "quiz" && <Quiz world={world} accent={accent} onComplete={onComplete} />}
        {tab === "breathe" && <BreathingExercise accent={accent} unlocked={breathingUnlocked} onComplete={onComplete} />}
        {tab === "reflect" && <ReflectionChat accent={accent} world={world} />}
      </div>
    </div>
  );
};
